<template>
  <VModal class="transfer-modal" name="template-transfer-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('template.transferTemplate') }}</h2>
    </template>
    <template v-slot:content>
      <p>{{ $t('template.transferTemplateWarning') }}</p>
      <VForm :onSubmit="validateForm" data-vv-scope="reminders-cancel" ref="form">
        <div slot="row">
          <VMessage v-if="errorMessage" type="error" subtype="basic">
            <template v-slot:icon>
              <LifeRingIcon />
            </template>
            <template v-slot:text>
              {{ errorMessage }}
            </template>
          </VMessage>
          <VGrid v-if="!loading">
            <div slot="gridItem" type="6">
              <VDropdown
                v-model="selectedUser"
                :list="orderedUsers"
                :map="{title: 'name'}"
                data-hj-suppress
                data-ec="templates_transfer_template_modal"
                data-et="user_dropdown"
              />
            </div>
          </VGrid>
        </div>
        <div slot="formButtons">
          <VButton
              type="warning"
              subtype="submit"
              class="float-right"
              href="#"
              :disabled="!selectedUser"
              data-ec="templates_transfer_template_modal"
              data-et="transfer_template_button">
            <UserIcon />
            <span>{{ $t('template.transferTemplate') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import { mapGetters } from 'vuex';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VDropdown from '@/components/deprecated/molecules/Dropdown.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { LifeRingIcon, UserIcon } from '@/components/icons/fontIcons';

export default {
  name: 'TemplateTransferModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    template: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VButton,
    VMessage,
    VForm,
    VModal,
    VDropdown,
    VGrid,
    UserIcon,
    LifeRingIcon,
  },
  computed: {
    ...mapGetters({
      users: 'users/pagedResults',
    }),
    orderedUsers() {
      const sortedUsers = JSON.parse(JSON.stringify(this.users)); // Don't edit original users list
      sortedUsers.sort((a, b) => {
        const compA = a.name ? a.name.toLowerCase() : '';
        const compB = b.name ? b.name.toLowerCase() : '';
        if (compA < compB) return -1;
        if (compA > compB) return 1;
        return 0;
      });
      return sortedUsers;
    },
  },
  data() {
    return {
      loading: true,
      errorMessage: null,
      selectedUser: null,
    };
  },
  mounted() {
    // Get list of ALL users
    this.$store.dispatch('users/PAGINATE', { page: 1, pageLimit: 1000 }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then((validated) => {
        if (!validated) {
          this.loading = false;
          return;
        }
        this.$store.dispatch('template/TRANSFER', { fingerprint: this.template.fingerprint, userId: this.selectedUser.id }).then((res) => {
          if (!res.error) this.$bus.$emit('closeModal');
          this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.success.transferred', { name: 'template' }), icon: 'check', type: 'success' }));
        }).finally(() => {
          this.loading = false;
        });
      });
    },
  },
};
</script>


<style scoped>
.transfer-modal ::v-deep .o-modal__box__content {
  overflow-y: visible;
}
</style>
